export const PASSWORD = "heslo123";
export const TRAVEL_ARRANGER_EMAIL = "travel.arranger@email.net";

const localBookedUrl = "http://cbt.localhost:3003/booked?status=";
export const DEALER_BODY = {
  AWS_TOPIC_ARN:
    "arn:aws:sns:eu-central-1:570717951219:reservation-waiting-for-approval-stage",
  CBT_TOKEN: "1iwDznSyFw7Gl0fTFIUR74ltCwANsbAca8B1HCGU",
  CBT_URL: "https://cbt-api-stage.cee-systems.com/v1",
  GOL_PAY_BACK_URL_FAIL: `${localBookedUrl}fail`,
  GOL_PAY_BACK_URL_OK: `${localBookedUrl}success`,
  GOL_PAY_BACK_URL_UNKNOWN: `${localBookedUrl}unknown`,
  PRICEINFO_COLUMNS: [
    "BaseFare",
    "TotalFare",
    "OperatorFee",
    "TotalPrice",
    "VatRate",
    "TotalPriceVat",
  ],
};
